import React from "react";



const TraceSpace = (props) => {

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right calc-item-heading">
                        Trace Space
                        &nbsp; &nbsp;
                    </div>

                    <div className="col-md-5 impedance-div-items">
                        <select className="form-control trace-select">
                            <option value="1">4</option>
                            <option value="2">4.5</option>
                            <option value="3">5</option>
                            <option value="4">5.5</option>
                            <option value="5">6</option>
                            <option value="6">6.5</option>
                            <option value="7">7.0</option>
                            <option value="8">7.5</option>
                            <option value="9">8</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default TraceSpace;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/CustomizationFormFields/TraceSpace.js